import MedCardIcon from "assets/menu-icons/MedCardIcon";

const medCard = {
  id: 'group-dashboard',
  type: 'group',
  restricted: true,
  children: [
    {
      id: 'medCard',
      title: 'Медкарта',
      type: 'item',
      url: 'medCard',
      icon: MedCardIcon,
      breadcrumbs: false,
      restricted: true,
    },
  ]
};

export default medCard;